import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/ai/ai_main_banner.webp";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service on_demand_banner cloud_cost_banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={7} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <h1 style={{ marginBottom: "10px" }}>AI Development Services</h1>
              <p>
                TekRevol is a leading AI software development company
                laser-focused on building, training and deploying AI-based
                algorithms, recommendation systems, business process automation
                systems and machine learning architectures that facilitate and
                accelerate your business cycle. We build solutions to scale
                AI-based startups, small to medium organizations and enterprise
                corporations so they can function and operate 3X better: smarter
                and faster.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Start AI Software Development
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
